module.exports = __webpack_public_path__ + "static/img/about4.66f2a306.png";